import cls from '../styles/Help.module.scss'
import { HeaderBar } from '@/components/HeaderBar'
import { Footer } from '@/components/Footer'

/* eslint-disable */
const Eula = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <HeaderBar showLogOutButton={false} />
      <div className={`${cls.help} flex-grow`}>
        <h1>Terms of service and conditions of use</h1>
        <hr />
        <h5>1) Acceptance of terms</h5>
        By using Appfluence`s online and offline products and services (collectively, "the
        Service"), provided by Appfluence, Inc. (collectively, "Appfluence," "We" or "Us")
        you agree to be bound by the following Terms of Service ("TOS"). The TOS may be
        updated by us from time to time without notice. You can review the most current
        version of the TOS at any time at: https://appfluence.com/eula/. By using the
        Service provided by Appfluence, you represent and agree that (i) you enter into
        this agreement either on your own, or on behalf of the company or other legal
        entity (collectively, the "Business User") that you may specify, (ii) that your
        account is for, and held in the name of, the Business User of individual named in
        the subscription, (iii) such Business User or individual has full legal capacity
        and is in good standing in the jurisdiction in which it is formed, (iv) you have
        full legal capacity and authority to bind yourself individually and such Business
        User to these TOS, and (iv) the terms "you" or "your," as used herein shall,
        unless the context otherwise reasonably requires, refer to both (A) such Business
        User, and (B) the individual or individuals (the "Individual User(s)") accessing
        or using the Service as authorized by such Business User; provided, however, that
        each such Individual User(s) shall remain vicariously liable and be required to
        comply with these TOS even though the account may be held in the name of the
        Business User. If you do not meet the requirements above, or if you do not agree
        with these terms and conditions, you may not use the Service. You understand and
        agree that the Service may include certain communications from Appfluence, such as
        service announcements and administrative messages, and that these communications
        are considered part of Appfluence membership and that you will not be able to opt
        out of receiving them. Changes and features that augment or enhance the current
        Service shall be subject to the TOS. You understand and agree that the Service is
        provided "as is" and that Appfluence assumes no responsibility for the timeliness,
        deletion, mis-delivery of or failure to store any user content or settings. You
        are responsible for obtaining access to the Service, which access may involve
        third-party fees (such as Internet Service Provider charges). You are responsible
        for those fees. In addition, you must provide and are responsible for all
        equipment necessary to access the Service. You may not access the Service for
        purposes of monitoring its performance, availability, or functionality, or for any
        other benchmarking or competitive purposes, without Appfluence's prior written
        consent. You may not access the Service if you are a direct competitor of
        Appfluence, except with Appfluence's prior written consent.
        <h5>2) Account</h5>
        In consideration of your use of the Service, you represent and warrant that (i)
        you are not barred from receiving services under the laws of the United States or
        any other applicable jurisdiction, (ii) your use of the Service does not violate
        any applicable law or regulation, and (iii) you access the Service through one or
        more humans. Accounts registered by "bots" or other automated methods are not
        permitted. You also agree to: (a) provide true, accurate, current and complete
        information about yourself as prompted by the Service's registration form
        ("Registration Data"); and (b) maintain and promptly update the Registration Data
        to keep it true, accurate, current and complete. If you provide any information
        that is untrue, inaccurate, not current or incomplete, or Appfluence has
        reasonable grounds to suspect that such information is untrue, inaccurate, not
        current or incomplete, Appfluence has the right to suspend or terminate your
        account and refuse any and all current or future use of the Service (or any
        portion thereof). Registration Data and certain other information about you is
        subject to our Privacy Policy which is incorporated by reference herein in its
        entirety. For more information, see our full privacy policy at
        https://appfluence.com/privacy/. You understand that through your use of the
        Service you consent to the collection and use (as set out in the Privacy Policy)
        of this information. You will receive a password and account designation upon
        completing the Service's registration process. You are responsible for maintaining
        the confidentiality of the password and account and are fully responsible for all
        activities that occur under your password or account. You agree to (a) immediately
        notify Appfluence of any unauthorized use of your password or account or any other
        breach of security; and (b) ensure that you exit from your account at the end of
        each session. Appfluence cannot and will not be liable for any loss or damage
        arising from your failure to comply with the TOS, including, without limitation,
        this Account Section.
        <h5>3) Billing</h5>
        We will bill you for subscription fees corresponding to your first subscription
        period, plus any applicable tax, at the moment your subscription starts. Unless
        otherwise stated explicitly, a subscription period has a duration of one year. To
        view the specific details of your subscription plan, you can see your "Account
        Management" page, available after logging into the Service. Unless cancelled, your
        Service subscription will be automatically renewed at the end of your subscription
        period. We will bill the subscription fee plus any applicable tax to you. Your
        membership will automatically renew for successive subscriptions, without prior
        notice to you, unless and until you cancel your membership, or we terminate it.
        You must cancel your membership before it renews in order to avoid billing of the
        next period's subscription fees to your payment method. By using the Service, you
        are expressly agreeing that we are permitted to bill you a subscription fee, any
        applicable tax and any other charges you may incur in connection with your use of
        the Service. Additional charges may include service level changes you request.
        Such additional charges can be requested in the middle of a subscription period,
        and will be billed immediately, in the amount corresponding to the remainder of
        the period. The subscription fee will be billed at the beginning of your
        subscription and on each renewal thereafter, unless and until you cancel your
        membership. We will automatically bill you each billing period on the calendar day
        corresponding to the commencement of your membership. All fees and charges are
        nonrefundable, and there are no refunds or credits for partially used periods, or
        where you have elected to downgrade service levels or otherwise remove any paid
        component or feature. If you elect to upgrade your service level or otherwise add
        any paid component or feature, we will pro-rate the amount due based on the number
        of days remaining in your billing cycle; provided, however, that any such
        proration shall be based on your service level or paid components or features in
        existence immediately prior to your election to upgrade or add paid components or
        features. We may change the fees and charges in effect or add new fees and charges
        from time to time. We will inform you of any increase or addition to existing fees
        and we may offer you a grace-period in which your fees will not increase for a
        certain period of time. If you do not accept the increase or addition to the
        existing fees, you may elect to terminate your account during the then current
        billing period and you shall not be liable for such fee increase after the
        applicable billing period; however, any later renewal of service will be subject
        to the increased fee structure. If your credit or debit card reaches its
        expiration date, your continued use of the Service constitutes your authorization
        for us to continue billing you, and you remain responsible for any uncollected
        amounts. If you change your service level (downgrade it), you may cause the loss
        of Content or features for your account. Appfluence does not accept any liability
        for such loss. You may cancel your subscription to the Service at anytime, and
        cancellation will be effective immediately. WE DO NOT PROVIDE REFUNDS OR CREDITS
        FOR ANY PARTIAL SUBSCRIPTION PERIODS OR ANY FEATURE OF COMPONENT THAT YOU HAVE
        PAID FOR BUT NOT USED. In connection with your purchase and/or use of the Service
        you may be subject to taxes, including, without limitation, sales and use taxes,
        by any authority which has jurisdiction to impose such taxes. You agree that the
        obligation and payment of any such taxes shall be your sole and absolute
        responsibility, and you agree to indemnify Appfluence pursuant to this agreement
        to the extent that Appfluence incurs any obligations or other liabilities in
        connection with such taxes.
        <h5>4) Content</h5>
        You understand that all information, data, text, files, or other materials
        ("Content"), whether publicly posted or privately transmitted, are the sole
        responsibility of the person from whom such Content originated. This means that
        you, and not Appfluence, are entirely responsible for all Content that you upload,
        post, email, transmit or otherwise make available via the Service. Appfluence does
        not control the Content posted via the Service and, as such, does not guarantee
        the accuracy, integrity or quality of such Content. You understand that by using
        the Service, you may be exposed to Content that is offensive, indecent,
        objectionable or illegal in your jurisdiction. Under no circumstances will
        Appfluence be liable in any way for any Content, including, but not limited to,
        any errors or omissions in any Content, or any loss or damage of any kind incurred
        as a result of the use of any Content posted, emailed, transmitted or otherwise
        made available via the Service. You agree to not use the Service to:
        <ul>
          <li>
            upload, post, email, transmit or otherwise make available any Content that is
            unlawful, harmful, threatening, abusive, harassing, tortuous, defamatory,
            vulgar, obscene, libelous, invasive of another's privacy, hateful, or
            racially, ethnically or otherwise objectionable, under any applicable laws;
          </li>
          <li> harm minors in any way;</li>
          <li>
            impersonate any person or entity, or falsely state or otherwise misrepresent
            your affiliation with a person or entity;
          </li>
          <li> disguise the origin of any Content transmitted through the Service;</li>
          <li>
            upload, post, email, transmit or otherwise make available any Content that you
            do not have a right to make available under any applicable law or under
            contractual or fiduciary relationships (such as inside information,
            proprietary and confidential information learned or disclosed as part of
            employment relationships or under nondisclosure agreements);
          </li>
          <li>
            upload, post, email, transmit or otherwise make available any Content that
            infringes any patent, trademark, trade secret, copyright or other proprietary
            rights of any party, unsolicited or unauthorized advertising, promotional
            materials, "junk mail", "spam", or any other form of solicitation, any
            material that contains software viruses or any other computer code, files or
            programs designed to interrupt, destroy or limit the functionality of any
            computer software or hardware or telecommunications equipment;
          </li>
          <li>
            act in a manner that negatively affects other users' ability to use the
            Service;
          </li>
          <li>
            interfere with or disrupt the Service or servers or networks connected to the
            Service, or disobey any requirements, procedures, policies or regulations of
            networks connected to the Service;
          </li>
          <li>
            intentionally or unintentionally violate any applicable local, state, national
            or international law;
          </li>
          <li>
            provide material support or resources (or to conceal or disguise the nature,
            location, source, or ownership of material support or resources) to any
            organization(s) designated by the United States government as a foreign
            terrorist organization pursuant to section 219 of the Immigration and
            Nationality Act.
          </li>
        </ul>
        You acknowledge that Appfluence may or may not pre-screen Content, but that
        Appfluence and its designees shall have the right (but not the obligation) in
        their sole discretion to pre-screen, refuse, or move any Content that is available
        via the Service. Without limiting the foregoing, Appfluence and its designees
        shall have the right to remove any Content that violates the TOS or is otherwise
        objectionable. You agree that you must evaluate, and bear all risks associated
        with, the use of any Content, including any reliance on the accuracy,
        completeness, or usefulness of such Content. In this regard, you acknowledge that
        you may not rely on any Content created by Appfluence or submitted to Appfluence.
        You acknowledge, consent and agree that Appfluence may access, preserve and
        disclose your account information and Content if required to do so by any
        applicable law or in a good faith belief that such access preservation or
        disclosure is reasonably necessary to: (a) comply with any applicable legal
        process; (b) enforce the TOS; (c) respond to claims that any Content violates the
        rights of third parties; (d) respond to your requests for customer service; or (e)
        protect the rights, property or personal safety of Appfluence, its users and the
        public. If we receive a subpoena which requests disclosure of information
        contained in your account you agree that we may disclose any such requested
        information contained in the account regardless of whether such information is
        deemed to be owned or held in the name of (i) the Business User, or (ii) the name
        of Individual Users. For the sake of clarity, (i) if the subpoena is issued in the
        name of the Business User, we may disclose information regarding both the Business
        User and the Individual User(s), and (ii) if the subpoena is issued in the name of
        Individual User(s) we may disclose information regarding both the Business User
        and the Individual Users(s). You understand that the technical processing and
        transmission of the Service, including your Content, may involve (a) transmissions
        over various networks; and (b) changes to conform and adapt to technical
        requirements of connecting networks or devices. You may not attempt to override or
        circumvent any of the usage rules embedded into the Service. Any unauthorized
        reproduction, publication, further distribution or public exhibition of the
        materials provided on the Service, in whole or in part, is strictly prohibited.
        Special admonitions for international use Recognizing the global nature of the
        Internet, you agree to comply with any and all applicable local, state, national
        or international laws and regulations regarding online conduct, acceptable Content
        and use of the Service. Specifically, you also agree to comply with all applicable
        laws regarding the transmission of technical data exported from the United States
        or the country or jurisdiction in which you reside.
        <h5>5) Confidentiality; Proprietary Rights</h5>
        Customer shall own all right, title and interest in and to the Customer Data.
        Company shall own and retain all right, title and interest in and to (a) any data
        that is based on or derived from the Customer Data and provided to Customer as
        part of the Services, (b) the Services and Software, all improvements,
        enhancements or modifications thereto, (c) any software, applications, inventions
        or other technology developed in connection with Implementation Services or
        support, and (d) all intellectual property rights related to any of the foregoing.
        Notwithstanding anything to the contrary, Company shall have the right collect and
        analyze data and other information relating to the provision, use and performance
        of various aspects of the Services and related systems and technologies
        (including, without limitation, information concerning Customer Data and data
        derived therefrom), and Company will be free (during and after the term hereof) to
        (i) use such information and data to improve and enhance the Services and for
        other development, diagnostic and corrective purposes in connection with the
        Services and other Company offerings, and (ii) disclose such data solely in
        aggregate or other de-identified form in connection with its business. No rights
        or licenses are granted except as expressly set forth herein.
        <h5>6) Administrator Access to Your Content</h5>
        When you sign up for our Service, you associate one or more email addresses with
        your account. If you use an email address provided to you by a third party entity
        of which you are a part (such as yourname@youremployer.com or
        yourname@nonprofit.org) (each an "Entity") you hereby grant that Entity and its
        administrator(s) permission to access, use, download, export, disclose, share,
        restrict and/or remove Content that you have associated with the email address
        that includes their domain. You acknowledge and understand that an Entity may
        elect to utilize one or more third party applications in connection with their
        teams' use of the Service and that, by associating Content with an email address
        that includes an Entity's domain, you are granting permission to have such Content
        shared with such third party application(s). You also acknowledge and understand
        that an Entity may restrict or terminate your access to Content associated with
        the email address that includes their domain. Please remember that you can
        associate more than one email address with your Appfluence account, so you may
        want to consider associating personal Content with a personal email address.
        <h5>7) Indemnity</h5>
        You agree to indemnify and hold Appfluence and its parent, subsidiaries,
        affiliates, officers, directors, stockholders, agents, attorneys, employees,
        partners, licensors and other representatives harmless from any claim or demand,
        including reasonable attorneys' fees, made by any third party due to or arising
        out of, or in connection with, (i) Content you submit, post, transmit or otherwise
        make available through the Service, (ii) your use or access of the Service, (iii)
        your connection to the Service, (iv) your violation of the TOS, (v) your violation
        of any rights of another, and (vi) any taxes arising in connection with your
        purchase or use of the Service in any jurisdiction, domestic or otherwise,
        including, without limitation, sales and use tax.
        <h5>8) No resale of Service</h5>
        You agree not to reproduce, duplicate, copy, sell, trade, resell or exploit for
        any commercial purposes, any portion of the Service, use of the Service, or access
        to the Service unless you otherwise have an agreement with us which specifically
        grants you such right(s).
        <h5>9) General practices regarding use and storage</h5>
        You acknowledge that Appfluence may establish general practices and limits
        concerning use of the Service, including without limitation the maximum number of
        days that Content will be retained by the Service, the maximum number of email
        messages that may be sent from or received by an account on the Service, the
        maximum size of any email message that may be sent from or received by an account
        on the Service, the maximum disk space that will be allotted on Appfluence's
        servers on your behalf, and the maximum number of times (and the maximum duration
        for which) you may access the Service in a given period of time. You agree that
        Appfluence has no responsibility or liability for the deletion or failure to store
        any Content and other communications maintained or transmitted by the Service. You
        acknowledge that Appfluence reserves the right to log off accounts that are
        inactive for an extended period of time. You further acknowledge that Appfluence
        reserves the right to modify these general practices and limits from time to time.
        <h5>10) Modifications to Service</h5>
        Appfluence reserves the right at any time and from time to time to modify or
        discontinue, temporarily or permanently, the Service (or any part thereof) with or
        without notice. You agree that Appfluence shall not be liable to you or to any
        third party for any modification, suspension or discontinuance of the Service.
        <h5>11) Marketing</h5>
        You agree to be identified as a customer of Appfluence and you agree that
        Appfluence may refer to you by name, trade name and trademark, if applicable, and
        may briefly describe your business in Appfluence's marketing materials and web
        site. You hereby grant Appfluence a fully-paid, irrevocable, perpetual, world-wide
        license to use your name and any of your trade names and trademarks solely in
        connection with the rights granted to Appfluence pursuant to this marketing
        section.
        <h5>12) Termination and cancellation</h5>
        You agree that Appfluence may without prior notice immediately terminate your
        Appfluence account and access to the Service (both as a Business User and/or
        Individual User(s)). Such termination may be made in Appfluence's sole and
        absolute discretion with or without cause. Further, you agree that all
        terminations for cause shall be made in Appfluence's sole and absolute discretion
        and that Appfluence shall not be liable to you or any third party for any
        termination of your account, or access to the Service.
        <h5>13) Appfluence's proprietary rights</h5>
        You acknowledge and agree that the Service and any necessary software used in
        connection with the Service ("Software") contain proprietary and confidential
        information that is protected by applicable intellectual property and other laws.
        Except as expressly authorized by Appfluence, you agree not to modify, rent,
        lease, loan, sell, distribute or create derivative works based on the Service or
        the Software, in whole or in part. Appfluence grants you a personal,
        non-transferable and non-exclusive right and license to use the object code of its
        Software on your computing devices, subject to the terms and conditions of this
        Agreement. You shall not (and shall not allow any third party to) copy, modify,
        create a derivative work from, reverse engineer, reverse assemble or otherwise
        attempt to discover any source code, sell, assign, sublicense, grant a security
        interest in or otherwise transfer any right in the Software. You agree not to
        modify the Software in any manner or form, or to use modified versions of the
        Software, including (without limitation) for the purpose of obtaining unauthorized
        access to the Service. You agree not to access the Service by any means other than
        through the interface that is provided by Appfluence for use in accessing the
        Service.
        <h5>14) Disclaimer of warranties</h5>
        <ul>
          <li> YOU EXPRESSLY UNDERSTAND AND AGREE THAT:</li>
          <li>
            YOUR USE OF THE SERVICE IS AT YOUR SOLE RISK. THE SERVICE IS PROVIDED ON AN
            "AS IS" AND "AS AVAILABLE" BASIS. APPFLUENCE AND ITS PARENT,SUBSIDIARIES,
            AFFILIATES, OFFICERS, DIRECTORS, STOCKHOLDERS, EMPLOYEES, AGENTS, ATTORNEYS,
            PARTNERS, LICENSORS AND OTHER REPRESENTATIVES EXPRESSLY DISCLAIM ALL
            WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED
            TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE
            AND NON-INFRINGEMENT.
          </li>
          <li>
            APPFLUENCE AND ITS PARENT, SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS,
            STOCKHOLDERS, EMPLOYEES, AGENTS, ATTORNEYS, PARTNERS, LICENSORS AND OTHER
            REPRESENTATIVES MAKE NO WARRANTY THAT: (i) THE SERVICE WILL MEET YOUR
            REQUIREMENTS; (ii) THE SERVICE WILL BE UNINTERRUPTED, TIMELY, SECURE OR
            ERROR-FREE; (iii) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICE
            WILL BE ACCURATE OR RELIABLE; (iv) THE QUALITY OF ANY PRODUCTS, SERVICES,
            INFORMATION OR OTHER MATERIAL PURCHASED OR OBTAINED BY YOU THROUGH THE SERVICE
            WILL MEET YOUR EXPECTATIONS; AND (v) ANY ERRORS IN THE SOFTWARE WILL BE
            CORRECTED.
          </li>
          <li>
            ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SERVICE
            IS ACCESSED AT YOUR OWN DISCRETION AND RISK, AND YOU WILL BE SOLELY
            RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT
            RESULTS FROM THE DOWNLOAD OF ANY SUCH MATERIAL.
          </li>
          <li>
            NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM
            APPFLUENCE OR THROUGH OR FROM THE SERVICE SHALL CREATE ANY WARRANTY NOT
            EXPRESSLY STATED IN THE TOS.
          </li>
        </ul>
        <h5>15) Limitation of liability</h5>
        YOU EXPRESSLY UNDERSTAND AND AGREE THAT APPFLUENCE AND ITS PARENT, SUBSIDIARIES,
        AFFILIATES, OFFICERS, DIRECTORS, STOCKHOLDERS, EMPLOYEES, AGENTS, ATTORNEYS,
        PARTNERS, LICENSORS AND OTHER REPRESENTATIVES SHALL NOT BE LIABLE TO YOU FOR ANY
        DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES,
        INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR
        OTHER INTANGIBLE LOSSES (EVEN IF Appfluence HAS BEEN ADVISED OF THE POSSIBILITY OF
        SUCH DAMAGES), RESULTING FROM: (i) THE USE OR THE INABILITY TO USE THE SERVICE;
        (ii) THE COST OF PROCUREMENT OF SUBSTITUTE GOODS AND SERVICES RESULTING FROM ANY
        GOODS, DATA, INFORMATION OR SERVICES PURCHASED OR OBTAINED OR MESSAGES RECEIVED OR
        TRANSACTIONS ENTERED INTO THROUGH OR FROM THE SERVICE; (iii) UNAUTHORIZED ACCESS
        TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; (iv) STATEMENTS OR CONDUCT OF ANY
        THIRD PARTY ON THE SERVICE; OR (v) ANY OTHER MATTER RELATING TO THE SERVICE.
        NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, APPFLUENCE'S MAXIMUM
        AGGREGATE LIABILITY TO YOU FOR ANY CAUSES WHATSOEVER, AND REGARDLESS OF THE FORM
        OF ACTION, WILL AT ALL TIMES BE LIMITED TO THE GREATER OF (i) THE AMOUNT PAID, IF
        ANY, BY YOU TO APPFLUENCE FOR THE SERVICE IN THE 12 MONTHS PRIOR TO THE ACTION
        GIVING RISE TO LIABILITY OR (ii) $100.
        <h5>16) Dispute Resolution</h5>
        You agree that prior to filing any claim against Appfluence relating to or arising
        out of these Terms you will first contact us at support+dispute@appfluence.com to
        provide us with an effort to resolve the issue in an informal manner. No Class
        Actions - ALL CLAIMS MUST BE BROUGHT ON AN INDIVIDUAL BASIS AND NOT AS A PLAINTIFF
        OR CLASS MEMBER IN ANY PURPORTED CLASS, CONSOLIDATED, OR REPRESENTATIVE
        PROCEEDING. CLASS ARBITRATIONS, CLASS ACTIONS, PRIVATE ATTORNEY GENERAL ACTIONS,
        AND CONSOLIDATION WITH OTHER ARBITRATIONS ARE NOT ALLOWED.
        <h5>17) Exclusions and limitations</h5>
        SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE
        LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES.
        ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.
        <h5>18) Trademark information</h5>
        The Appfluence and Delayed Send name and logo trademarks and service marks and
        other Appfluence logos and product and service names are trademarks of Appfluence.
        <h5>19) Export Law Assurances</h5>
        You may not use or otherwise export or reexport the Service except as authorized
        by United States law and the laws of the jurisdiction in which Appfluence was
        obtained. In particular, but without limitation, the Service may not be exported
        or re-exported (a) into (or to a national or resident of) any U.S. embargoed
        countries (currently Cuba, Iran, North Korea, Sudan, and Syria) or (b) to anyone
        on the U.S. Treasury Department's list of Specially Designated Nationals or the
        U.S. Department of Commerce Denied Person's List or Entity List or Unverified List
        or Blocked Persons List or Debarred List on Nonproliferation Sanctions List. By
        using the Service, you represent and warrant that you are not located in, under
        control of, or a national or resident of any such country or on any such list.
        <h5>20) General information</h5>
        Entire Agreement. The TOS constitute the entire agreement between you and
        Appfluence and govern your use of the Service, superseding any prior agreements
        between you and Appfluence with respect to the Service. You also may be subject to
        additional terms and conditions that may apply when you use or purchase certain
        other Appfluence services, affiliate services, third-party content or third-party
        software. Choice of Law and Forum. The TOS and the relationship between you and
        Appfluence shall be governed by the laws of the State of California without regard
        to its conflict of law provisions. You and Appfluence agree to submit to the
        personal and exclusive jurisdiction of the courts located within the County of
        Santa Clara, State of California regardless of (i) your world-wide physical
        location, or (ii) the jurisdiction where you purchased or use the Service. Notice
        and Future Changes. Appfluence may provide you with notices, including those
        regarding modifications to the TOS (including the Privacy Policy), by email or via
        the web-site. You agree to review the TOS (including the Privacy Policy)
        periodically so that you are aware of any modifications. Your continued use of the
        Service after any modifications indicates your acceptance of the modified TOS (and
        all other agreements, policies, rules and guidelines referred to herein). Unless
        expressly stated otherwise by Appfluence, any new features, new services,
        enhancements or modifications to the Service implemented after your initial access
        to the Service shall be subject to these TOS. Waiver and Severability of Terms.
        The failure of Appfluence to exercise or enforce any right or provision of the TOS
        shall not constitute a waiver of such right or provision. If any provision of the
        TOS is found by a court of competent jurisdiction to be invalid under applicable
        law, the parties nevertheless agree that the court should endeavor to give effect
        to the parties' intentions to the greatest extent possible as reflected in the
        provision, and the other provisions of the TOS shall remain in full force and
        effect. No Right of Survivorship and Non-Transferability. You agree that your
        Appfluence account is non-transferable and any rights to your Appfluence account
        or contents within your account terminate upon cessation of your legal existence
        or death, as applicable. Upon receipt of a copy of a certificate of dissolution or
        death certificate, as applicable, your account may be terminated and all contents
        therein permanently deleted. Statute of Limitations. You agree that regardless of
        any statute or law to the contrary, any claim or cause of action arising out of or
        related to use of the Service or the TOS must be filed within one (1) year after
        such claim or cause of action arose or be forever barred. The section titles in
        the TOS are for convenience only and have no legal or contractual effect.
      </div>
      <Footer />
    </div>
  )
}

export default Eula